import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { AppError } from "../../../app-error/app-error.model";

import { MultiDepositLimit, MultiDepositLimits } from "./multi-deposit-limit.model";

export const ACTION_PREFIX = "[Multi Deposit Limit]";
export const MULTI_DEPOSIT_LIMIT_ACTION_TYPE = {
	get: `${ACTION_PREFIX} Get`,
	getSuccess: `${ACTION_PREFIX} Get Success`,
	getFail: `${ACTION_PREFIX} Get Fail`,

	update: `${ACTION_PREFIX} Update`,
	updateSuccess: `${ACTION_PREFIX} Update Success`,
	updateFail: `${ACTION_PREFIX} Update Fail`,

	clear: `${ACTION_PREFIX} Clear ${SYNC_SUFFIX}`,
	resetDependencies: `${ACTION_PREFIX} Reset Dependencies ${SYNC_SUFFIX}`,
};

/**
 * @deprecated [fabric-deprecated] - Use MultiDepositLimitService from app-responsible-gaming instead
 */
@Injectable({
	providedIn: "root",
})
export class MultiDepositLimitAction {
	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetMultiDepositLimits instead
	 */
	get(): Action {
		return {
			type: MULTI_DEPOSIT_LIMIT_ACTION_TYPE.get,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetMultiDepositLimits instead
	 */
	getSuccess(payload: MultiDepositLimits): ActionWithPayload {
		return {
			type: MULTI_DEPOSIT_LIMIT_ACTION_TYPE.getSuccess,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetMultiDepositLimits instead
	 */
	getFail(error: AppError): ActionWithPayload {
		return {
			type: MULTI_DEPOSIT_LIMIT_ACTION_TYPE.getFail,
			payload: error,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateMultiDepositLimit instead
	 */
	update(payload: MultiDepositLimit): ActionWithPayload {
		return {
			type: MULTI_DEPOSIT_LIMIT_ACTION_TYPE.update,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateMultiDepositLimit instead
	 */
	updateSuccess(payload: MultiDepositLimits): ActionWithPayload {
		return {
			type: MULTI_DEPOSIT_LIMIT_ACTION_TYPE.updateSuccess,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.UpdateMultiDepositLimit instead
	 */
	updateFail(error: AppError): ActionWithPayload {
		return {
			type: MULTI_DEPOSIT_LIMIT_ACTION_TYPE.updateFail,
			payload: error,
		};
	}

	clear(): Action {
		return {
			type: MULTI_DEPOSIT_LIMIT_ACTION_TYPE.clear,
		};
	}

	resetDependencies(): Action {
		return {
			type: MULTI_DEPOSIT_LIMIT_ACTION_TYPE.resetDependencies,
		};
	}
}
